import { makeStyles } from 'src/utils/makeStyles';

const styles = makeStyles({
  field: {
    width: theme => theme.spacing(8),
  },
  input: {
    height: theme => theme.spacing(4),
    py: 0.75,
    px: 1.25,
    '& input': {
      textAlign: 'right',
    },
  },
  readOnly: {
    boxShadow: 'none',
    pointerEvents: 'none',
  },
});

export default styles;
